import {header} from "./header";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {discountsList_template} from "../components/templates/discountsList_template";

declare var ko: any;
declare var page: any;

export class discounts extends vnModule_knockoutJS {

    protected discountsListTemplate: discountsList_template;
    protected timer;
    protected static STATUS_OPTIONS = [
        { id: '1', name: 'Active' },
        { id: '0', name: 'Inactive' }
    ];

    protected getModuleName(): string {
        return "discounts";
    }

    buildContent(): Element[] {
        this.discountsListTemplate = new discountsList_template("list", this.viewModel, this);
        this.template = this.discountsListTemplate;

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        (loadedModule as header).setHeaderTitle("Discounts List");

        return [this.discountsListTemplate.build()];
    }

    public fillPage(): void {
        this.discountsListTemplate.setStatusFilterItems(discounts.STATUS_OPTIONS);
        this.getReferences();
        this.getListFormData();
    }

    protected getReferences(): void {
        const self = this;
        const idBrand = this.getVnAppZone().app.params.idBrand;

        // Get categories for filter
        if (this.XHRHdls['categories']) {
            this.XHRHdls['categories'].cancelAndReset();
        }

        const catUrl = '/api/discounts/categories/tree/';
        const catParams: string[][] = [];
        catParams.push(["data", ko.toJSON({ brandId: idBrand })]);
        this.XHRHdls['categories'] = new XMLHttpRequestHandler(catUrl, catParams, this);
        this.XHRHdls['categories'].onReadyStateFunction = this.onGetCategoriesReturn;
        this.XHRHdls['categories'].execute();

        // Get branches for filter
        if (this.XHRHdls['branches']) {
            this.XHRHdls['branches'].cancelAndReset();
        }

        const branchUrl = '/api/discounts/branches/get/';
        const branchParams: string[][] = [];
        branchParams.push(["data", ko.toJSON({ brandId: idBrand })]);
        this.XHRHdls['branches'] = new XMLHttpRequestHandler(branchUrl, branchParams, this);
        this.XHRHdls['branches'].onReadyStateFunction = this.onGetBranchesReturn;
        this.XHRHdls['branches'].execute();
    }

    protected onGetCategoriesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                if (response.categories) {
                    const flatCategories = obj.flattenCategories(response.categories);
                    obj.discountsListTemplate.setCategoryOptions(flatCategories);
                }
            });
        };
    }

    protected onGetBranchesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                if (response.branches) {
                    obj.discountsListTemplate.setBranchOptions(response.branches);
                }
            });
        };
    }

    protected flattenCategories(categories: any[], parentName: string = ''): any[] {
        let flat: any[] = [];
        for (const rawNode of categories) {
            const category = rawNode.category ? rawNode.category : rawNode;
            if (!category || typeof category.id === 'undefined' || typeof category.name === 'undefined') {
                continue;
            }

            const displayName = parentName ? `${parentName} > ${category.name}` : category.name;
            flat.push({ id: category.id, name: displayName });

            if (rawNode.children && rawNode.children.length > 0) {
                flat = flat.concat(this.flattenCategories(rawNode.children, displayName));
            }
        }
        return flat;
    }

    public getListFormData(): void {
        if (this.XHRHdls['discounts']) {
            this.XHRHdls['discounts'].cancelAndReset();
        }
        this.loadingIn(this.discountsListTemplate.builtTemplate.children.namedItem("list-results"));

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/get/';
        const usrReq_params: string[][] = [];

        usrReq_params.push(["data", ko.toJSON({ brandId: idBrand })]);
        this.XHRHdls['discounts'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['discounts'].onReadyStateFunction = this.onListFormDataRequestReturn;
        this.XHRHdls['discounts'].execute();
    }

    protected onListFormDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response);
                obj.discountsListTemplate.setListData(response.discounts || []);
                
                const execTime = Math.round((new Date().getTime() - obj.XHRHdls['discounts'].requestStartTime) / 1000 * 100) / 100;
                obj.discountsListTemplate.setResultInfo(
                    response.totalCount || (response.discounts ? response.discounts.length : 0),
                    response.totalPage || 1,
                    execTime
                );
            });

            obj.loadingOut(obj.discountsListTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    public filterList(): void {
        if (this.XHRHdls['discounts']) {
            this.XHRHdls['discounts'].cancelAndReset();
        }

        this.loadingIn(this.discountsListTemplate.builtTemplate.children.namedItem("list-results"));

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/get/';
        this.timer = new Date().getTime();

        const subViewModel: any = this.discountsListTemplate.getViewModelForRequest();
        subViewModel.brandId = idBrand;

        this.sendFilterCall(
            usrReq_url,
            subViewModel,
            this.onFilterRequestReturn,
            XMLHttpRequestHandler_requestType.GET,
            'discounts',
            this.discountsListTemplate.builtTemplate.children.namedItem("list-results")
        );
    }

    protected onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });

            obj.loadingOut(obj.discountsListTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    protected updateList(response: any): void {
        this.discountsListTemplate.setListData(response.discounts || []);
        const execTime = Math.round((new Date().getTime() - this.timer) / 1000 * 100) / 100;
        this.discountsListTemplate.setResultInfo(
            response.totalCount || (response.discounts ? response.discounts.length : 0),
            response.totalPage || 1,
            execTime
        );
    }

    protected add() {
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/discounts/add/');
    }

    protected viewDiscount(id: number): void {
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/discounts/view/' + id + '/');
    }

    protected editDiscount(id: number): void {
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/discounts/edit/' + id + '/');
    }

    protected delete(id: number): void {
        if (this.XHRHdls['delete-discount']) {
            this.XHRHdls['delete-discount'].cancelAndReset();
        }

        this.loadingIn(this.discountsListTemplate.builtTemplate.children.namedItem("list-results"));

        const idBrand = this.getVnAppZone().app.params.idBrand;
        const usrReq_url: string = '/api/discounts/delete/' + id + '/';
        const usrReq_params: string[][] = [];
        usrReq_params.push(["data", ko.toJSON({ brandId: idBrand })]);

        this.XHRHdls['delete-discount'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['delete-discount'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['delete-discount'].onReadyStateFunction = this.onDeleteDiscountReturn;
        this.XHRHdls['delete-discount'].execute();
    }

    protected onDeleteDiscountReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.filterList();
            });
            obj.loadingOut(obj.discountsListTemplate.builtTemplate.children.namedItem("list-results"));
        };
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected filterSimpleOnChange(idElement) {
        this.discountsListTemplate.setPageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel() {
        if (this.XHRHdls['discounts']) {
            (this.XHRHdls['discounts'] as XMLHttpRequestHandler).cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange() {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(idElement) {
        this.discountsListTemplate.setPageNumber(1);
        this.filterList();
    }
}



// WEBPACK FOOTER //
// ./js/modules/discounts.ts